export default __webpack_public_path__ + "static/og-38bcc03ffdcd26fa5efcd990ca0a2b9b.png";